import { Gift } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { routes } from "@/lib/routes";

export const GiftBanner = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div
      onClick={() => navigate(routes.giftExperience())}
      className="w-full bg-gradient-to-r from-primary via-primary/90 to-secondary cursor-pointer hover:opacity-95 transition-opacity"
    >
      <div className="container flex items-center justify-center gap-2 py-2 px-4">
        <Gift className="h-4 w-4 text-primary-foreground" />
        <span className="text-sm font-medium text-primary-foreground">
          {t('gift.bannerTitle')}
        </span>
        <span className="text-xs text-primary-foreground/80 hidden sm:inline">
          {t('gift.bannerSubtitle')}
        </span>
      </div>
    </div>
  );
};
